import React from "react";
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  Text,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { GOLD_TEXT } from "constants/brandColors";
import { REQUIRED_LOCALE_CODE } from "utils/translations";

const fieldProps = {
  bg: "white",
};

// One "Name" input per active locale, in a tab per language — the shared
// piece of Category/SubCategory/Tag create+edit forms, mirroring the tab
// pattern News already uses for its per-locale fields.
function LocaleNameTabs({ locales, translations, errors = {}, onChange, borderColor }) {
  const { t } = useTranslation();
  return (
    <Tabs mt="16px" colorScheme="gray" variant="enclosed">
      <TabList overflowX="auto" overflowY="hidden" flexWrap="nowrap" sx={{ scrollbarWidth: "thin" }}>
        {locales.map(({ code, label }) => (
          <Tab key={code} whiteSpace="nowrap" flexShrink={0} _selected={{ color: GOLD_TEXT, borderColor: "gray.200", borderBottomColor: "white", fontWeight: "700" }}>
            {label}
            {code === REQUIRED_LOCALE_CODE && <Text as="span" color="red.500" ml="4px">*</Text>}
          </Tab>
        ))}
      </TabList>
      <TabPanels borderWidth="1px" borderTop="none" borderColor="gray.200" borderBottomRadius="md" p="12px">
        {locales.map(({ code }) => {
          const name = translations[code]?.name || "";
          const isRtl = code === "ar";
          return (
            <TabPanel key={code} p="4px">
              <FormControl isInvalid={!!errors[code]}>
                <FormLabel fontSize="sm" fontWeight="500" color={GOLD_TEXT}>{t("Name")}</FormLabel>
                <Input
                  isRequired={code === REQUIRED_LOCALE_CODE}
                  dir={isRtl ? "rtl" : "ltr"}
                  value={name}
                  onChange={(e) => onChange(code, e.target.value)}
                  {...fieldProps}
                  borderColor={borderColor}
                  focusBorderColor={borderColor}
                />
                <FormErrorMessage>{errors[code]}</FormErrorMessage>
              </FormControl>
            </TabPanel>
          );
        })}
      </TabPanels>
    </Tabs>
  );
}

export default LocaleNameTabs;
